import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import orderApi from '../../services/Order/orderApi';

function CouponSelectPopup({ isPopup, setIsPopup, onConfirm, settlePrice, orderType }) {
  const location = useLocation();
  const [popupActive, setPopupActive] = useState(false);
  const [selectedCoupon, setSelectedCoupon] = useState(null);
  const [coupons, setCoupons] = useState([]);

  useEffect(() => {
      const body = document.body;
      body.style.overflow = isPopup ? 'hidden' : 'auto';
      return () => {
          body.style.overflow = 'auto';
      };
  }, [isPopup]);

  useEffect(() => {
    if (isPopup && typeof settlePrice === 'number') {
      const fetchCoupons = async () => {
        try {
          const response = await orderApi.getCouponList({
            settlePrice,
            order_kind: orderType
          });
          setCoupons(response.data.data);
        } catch (error) {
          console.error('쿠폰 조회 오류:', error);
        }
      };
      fetchCoupons();
    }
  }, [isPopup, settlePrice, orderType]);


  useEffect(() => {
      let timeout;
      if (isPopup) {
          timeout = setTimeout(() => {
              setPopupActive(true);
          }, 100);
      } else {
          setPopupActive(false);
      }
      return () => clearTimeout(timeout);
  }, [isPopup]);

  useEffect(() => {
      document.body.style.overflow = 'auto';
  }, [location]);

  const handleClose = (e) => {
      e.preventDefault();
      setIsPopup(false);
  };

  const handleCouponSelect = (index) => {
    setSelectedCoupon(index);
  };

  const handleConfirm = () => {
    if (selectedCoupon === -1) {
      onConfirm("", 0);
    } else if (selectedCoupon !== null) {
      const selectedCouponData = coupons[selectedCoupon];
      onConfirm(selectedCouponData.download_seq);
    }
    setIsPopup(false);
  };

  // 딤 배경 클릭 핸들러 추가
  const handleBackgroundClick = (e) => {
    // popup-box-component 클래스를 가진 최상위 div를 클릭했을 때만 팝업 닫기
    if (e.target.className === 'popup-box-component') {
      setIsPopup(false);
    }
  };

  if (isPopup)
      return (
          <div 
            className="popup-box-component"
            onClick={handleBackgroundClick}
          >
            <div className={`box content ${popupActive ? 'active' : ''}`}>
              <div className="popup_container">
                <h4 className="pop_title">사용 가능 쿠폰</h4>
                <div className='close_btn_con'>
                <button
                  type="button" 
                  className="close_btn"
                  onClick={handleClose}
                />
              </div>
                <div className="coupon_list">
                  <ul className="coupon_con">
                    <li 
                      className={`coupon_item flex-12 column ${selectedCoupon === -1 ? 'selected' : ''}`}
                      onClick={() => handleCouponSelect(-1)}
                    >
                      <div className="flex-4 column">
                        <span className="b1-1">
                        선택 안 함
                        </span>
                      </div>
                    </li>

                    {coupons.length > 0 ? (
                      coupons.map((coupon, index) => (
                        <li 
                          key={index}
                          className= {`coupon_item flex-12 column ${selectedCoupon === index ? 'selected' : ''}`}
                          onClick={() => handleCouponSelect(index)}
                        >
                          <div className="flex-4 column">
                            <p className="p2 red">
                              {coupon.coupon_name}
                            </p>
                            <span className="b1-1">
                              [{coupon?.coupon_val}% 혜택] {coupon?.coupon_desc}
                            </span>
                          </div>
                          <div>
                            <span className="b2-2 g-80">
                              {coupon?.use_end_date.split(' ')[0]} 까지
                            </span>
                          </div>
                        </li>
                      ))
                    ) : (
                      <li className="coupon_item flex-12 column no-coupon">
                        <div className="flex-4 column">
                          <span className="b1-1 text-center">
                            보유한 쿠폰이 없습니다.
                          </span>
                        </div>
                      </li>
                    )}
                  </ul>
                </div>

                <div className='pop_btn_wrap'>
                  <button 
                    type="button"
                    className="default_btn black pop_con_btn" 
                    onClick={handleConfirm}
                  >
                    선택 쿠폰 사용하기
                  </button>
                </div>
              </div>
            </div>
          </div>
      );
}

export default CouponSelectPopup;
